module.exports = __webpack_public_path__ + "img/catherine-grayson.5da286c3.jpg";